var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.file.path,"type":"video/mp4"}}),_vm._v(" Sorry, your browser doesn't support embedded videos. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }